import React, { useState, useEffect } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { X } from "lucide-react";

const CookieBanner = () => {
  const [showBanner, setShowBanner] = useState(false);

  useEffect(() => {
    const consent = localStorage.getItem('introzzi_cookie_consent');
    if (!consent) {
      // Small delay to not interfere with splash screen
      const timer = setTimeout(() => setShowBanner(true), 4500);
      return () => clearTimeout(timer);
    }
  }, []);

  const handleAccept = () => {
    localStorage.setItem('introzzi_cookie_consent', 'accepted');
    setShowBanner(false);
  };

  const handleDecline = () => {
    localStorage.setItem('introzzi_cookie_consent', 'declined');
    setShowBanner(false);
  };

  return (
    <AnimatePresence>
      {showBanner && (
        <motion.div
          className="fixed bottom-0 left-0 right-0 z-[150] p-4 sm:p-6"
          initial={{ opacity: 0, y: 100 }}
          animate={{ opacity: 1, y: 0 }}
          exit={{ opacity: 0, y: 100 }}
          transition={{ duration: 0.4 }}
          data-testid="cookie-banner"
        >
          <div className="max-w-4xl mx-auto bg-[#0A0A0A]/95 backdrop-blur-xl border border-white/10 p-6 sm:p-8">
            <div className="flex flex-col sm:flex-row items-start sm:items-center gap-6">
              <div className="flex-1">
                <h3 className="text-white text-sm font-medium mb-2">Cookie Policy</h3>
                <p className="text-gray-400 text-sm font-light leading-relaxed">
                  We use cookies to enhance your browsing experience and analyze site traffic. 
                  By clicking "Accept", you consent to our use of cookies.
                </p>
              </div>
              <div className="flex items-center gap-3 w-full sm:w-auto">
                <button
                  onClick={handleDecline}
                  className="flex-1 sm:flex-none px-6 py-3 border border-white/20 rounded-full text-white text-sm tracking-wider hover:border-white/40 transition-colors"
                  data-testid="cookie-decline-btn"
                >
                  Decline
                </button>
                <button
                  onClick={handleAccept}
                  className="flex-1 sm:flex-none px-6 py-3 border border-white rounded-full text-white text-sm tracking-wider hover:bg-white hover:text-black transition-colors"
                  data-testid="cookie-accept-btn"
                >
                  Accept
                </button>
              </div>
            </div>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};

export default CookieBanner;
